import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';                          // Updated import: App, not AppComponent
import { appConfig } from './app/app.config';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

bootstrapApplication(App, {
  providers: [
    provideAnimationsAsync()
  ]
});


bootstrapApplication(App, appConfig)                      // Updated: App, not AppComponent
  .catch(err => console.error(err));
